import styled from 'styled-components';

export const CategoryWrapperStyled = styled.section`
  width: 100%;
  z-index: 1;
  position: relative;
`;

export const OfferWrapper = styled.div`
  margin-right: 2.2rem;
  display: ${p => p.theme.category.promotionOnTop.display};
  flex-direction: column;
`;

export const IconWrapper = styled.div`
  width: 100%;
  display: ${p => p.theme.category.promotionOnTop.display};
  justify-content: center;
  padding-top: 2rem;
  background-color: ${p => p.theme.quinaryBackground};
`;

export const OfferTitle = styled.div`
  width: ${p => p.isTemplateLight ? '100%' : 'auto'};
  text-align: center;
  font-size: 2rem;
  padding-top: 1.2rem;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  font-weight: bold;
  color: ${p => p.theme.textColor};
  background-color: ${p => p.theme.quinaryBackground};
  margin: ${p => p.isTemplateLight ? 0 : '0 1.2rem'};
`;



// WEBPACK FOOTER //
// ./components/Categories/Categories.style.js